import { Box, Button, CircularProgress, Tooltip } from "@mui/material";
import { getSettings } from "apis/controllers/common";
import background from "assets/images/login-background.png";
import UnderConstruction from "pages/UnderConstruction";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // ✅ Loading state

  const handleCitizenLogin = () => {
    navigate("/pubnr/login");
  };

  const handleEmployeeLogin = () => {
    navigate("/govnr/login");
  };

  const fetchSettings = async () => {
    try {
      const res = await getSettings();
      const getValue = (key) =>
        res.data.find((d) => d.dataKey === key)?.dataValue;
      setSettings({
        project_pubnr_login_enabled:
          getValue("project_pubnr_login_enabled") === "true",
        project_under_construction:
          getValue("project_under_construction") === "true",
        project_pubnr_login_disabled_msg: getValue(
          "project_pubnr_login_disabled_msg"
        ),
        project_under_construction_msg: getValue(
          "project_under_construction_msg"
        ),
      });
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setIsLoading(false); // ✅ Done loading, even if error
    }
  };

  useEffect(() => {
    if (window.location.pathname === "/lae-miteres") {
      window.history.replaceState({}, "", "/lae-miteres/");
    }
    fetchSettings();
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return settings?.project_under_construction ? (
    <UnderConstruction msg={settings?.project_under_construction_msg} />
  ) : (
    <div
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.8)), url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "70vh",
        width: "100%",
        marginTop: "-18px",
      }}
    >


      <div className="landing-content">
        <h2 className="landing-subtitle">
          Παροχή Χρηματικών Βοηθημάτων σε Δικαιούχους ΛΑΕ/ΟΠΕΚΑ
        </h2>




        <h3 className="landing-description">

          <ul>
            <li>
              <strong>Μητέρες (
                Τρίτεκνες / Πολύτεκνες)</strong>
            </li>
            <li>
              <strong>
                Υποτροφίες Επιτυχόντων τέκνων τους στις Πανελλαδικές Εξετάσεις
              </strong>
            </li>
          </ul>

          <p>
            Καλωσορίσατε στην ψηφιακή πλατφόρμα υποβολής αιτήσεων για τη
            <strong> χορήγηση χρηματικού βοηθήματος σε τρίτεκνες και πολύτεκνες
              μητέρες</strong> και <strong>τα επιτυχόντα στις Πανελλαδικές Εξετάσεις τέκνα τους</strong>, στο πλαίσιο του Προγράμματος Κοινωνικού
            Χαρακτήρα του Λογαριασμού Αγροτικής Εστίας (ΛΑΕ) του ΟΠΕΚΑ.
          </p>
          <br />
          <p>
            {" "}
            Η πλατφόρμα παρέχει έναν φιλικό και ασφαλή τρόπο για την πλήρη ηλεκτρονική υποβολή αίτησης, με δυνατότητα αυτόματης άντλησης δικαιολογητικών και διασταύρωσης στοιχείων, σύμφωνα με τις προδιαγραφές του προγράμματος και τις διατάξεις της σχετικής Κοινής Υπουργικής Απόφασης.
          </p>
          <br />
          <p>
            {" "}
            Οι δικαιούχοι μητέρες μπορούν εύκολα να ενημερωθούν για τις
            προϋποθέσεις συμμετοχής, να ξεκινήσουν νέα αίτηση, να υποβάλουν και
            να παρακολουθούν την πορεία της λαμβάνοντας έγκαιρες ειδοποιήσεις
            για οποιαδήποτε ενέργεια απαιτείται.
          </p>
          <br />
          <p>
            <text style={{ fontSize: "1.25rem" }}>
              <strong>Οι αιτήσεις για συμμετοχή στα προγράμματα παροχής χρηματικών βοηθημάτων υποβάλλονται πλέον ηλεκτρονικά</strong>, ακολουθώντας τους παρακάτω συνδέσμους ανάλογα με το αν είστε <strong>(α) πολίτης που επιθυμεί να υποβάλει ηλεκτρονικά ή/και να ελέγξει την πορεία της αίτησής του</strong>, ή (β) υπάλληλος / εξουσιοδοτημένος χρήστης του ΟΠΕΚΑ.

            </text>
          </p>

        </h3>
        <div className="landing-buttons">
          <Tooltip title={settings?.project_pubnr_login_disabled_msg || ""}>
            <span>
              <Button
                variant="contained"
                disabled={!settings?.project_pubnr_login_enabled}
                color="primary"
                size='large'
                onClick={handleCitizenLogin}
                sx={{
                  fontWeight: 'bold',
                  fontSize: 19,
                  padding: '9px 22px',
                  height: '42px', // Explicitly set height
                  lineHeight: 1, // Prevent line height from expanding the button
                }}
              >
                Είσοδος για πολίτες
              </Button>
            </span>
          </Tooltip>
          <Button
            size="large"
            sx={{ marginBottom: 2, marginLeft: 'auto' }}
            variant="contained"
            color="info"
            onClick={handleEmployeeLogin}
          >
            Είσοδος για Υπαλλήλους
          </Button>
        </div>
      </div>

    </div>
  );
};

export default LandingPage;
